import { Attribute, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[errorAnchor]'
})
export class ErrorAnchorDirective {

  constructor(private host: ElementRef<HTMLElement>,) { }

  get element() {
    return this.host.nativeElement;
  }

}


@Directive({
  selector: 'form'
})
export class FpxFormAnchorDirective {

  constructor(private host: ElementRef<HTMLElement>,
    @Attribute("formName") private name: string,) { }

  get element() {
    return this.host.nativeElement;
  }

  get formName() {
    return this.name
  }

}
